export const activationValidators = {
  email: {
    presence: {
      allowEmpty: false,
      message: "is required"
    },
    email: {
      message: "should be a valid email"
    }
  },
  domain: {
    presence: {
      allowEmpty: false,
      message: "is required"
    },
  },
};

export const modalOptionsValidate = {
  title: {
    type: {
      type: "string",
      message: "should be type string"
    }
  },
  content: {
    type: {
      type: "string",
      message: "should be type string"
    }
  },
  acceptText: {
    type: {
      type: "string",
      message: "should be type string"
    }
  },
  rejectText: {
    type: {
      type: "string",
      message: "should be type string"
    }
  },
  icon: {
    type: {
      type: "string",
      message: "should be type string"
    },
    url: {
      allowLocal: false,
      schemes: ["http", "https"],
      message: "is not a valid url",
    }
  },
  position: {
    presence: {
      message: "is required",
    },
    type: {
      type: "string",
      message: "should be type string"
    }
  },
  mobilePosition: {
    presence: {
      message: "is required",
    },
    type: {
      type: "string",
      message: "should be type string"
    }
  },
  retry: {
    format: {
      pattern: "[0-9.]+",
      message: "Enter a valid number"
    }
  },
  direction: {
    presence: {
      message: "is required",
    },
    type: {
      type: "string",
      message: "should be type string"
    }
  },
};